/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ComponentType, FC } from 'react'
import React from 'react'

import type { WithThemeProps } from './types'
import { useSafeThemeUI } from './use-theme-ui'

const withThemeUI = <P extends object>(
  Component: ComponentType<P>
): React.FC<P & WithThemeProps> => {
  const _withThemeUI: FC<P & WithThemeProps> = props => {
    const theme = useSafeThemeUI(props)
    return <Component {...{ ...props, theme: theme }} />
  }
  return _withThemeUI
}

export default withThemeUI
